/* ==========================================================================
   ProTan native cart add-ons + cart accessibility
   Replaces Rebuy Smart Cart behaviour using Motion's own cart drawer.
   - "Add" buttons in the cart add-on list
   - "Remove" buttons on cart lines
   - Focus is kept on a sensible control after the cart re-renders
   - Changes are announced to screen readers
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var pendingFocus = null; // { type: 'qty'|'remove'|'added', key, variant, cls }

  function status() {
    var el = doc.getElementById('CartStatus');
    if (!el) {
      el = doc.createElement('div');
      el.id = 'CartStatus';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      doc.body.appendChild(el);
    }
    return el;
  }
  function announce(msg) {
    var el = status();
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  }
  function money(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) { return ''; }
  }
  function cartIsOpenDrawer() {
    var d = doc.getElementById('CartDrawer');
    return d && d.classList.contains('drawer--is-open') ? d : null;
  }
  function rebuild() {
    doc.dispatchEvent(new CustomEvent('cart:build'));
  }

  /* Add an add-on from the cart list */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-upsell-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('btn--loading');
    var title = btn.getAttribute('data-upsell-title') || '';
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-upsell-add'), 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) {
          btn.disabled = false;
          btn.classList.remove('btn--loading');
          announce(res.description || res.message || 'Could not add to cart');
          return;
        }
        announce(title + ' added to your cart.');
        if (doc.body.classList.contains('template-cart')) { window.location.reload(); return; }
        pendingFocus = { type: 'added', variant: btn.getAttribute('data-upsell-add') };
        rebuild();
        doc.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () { btn.disabled = false; btn.classList.remove('btn--loading'); });
  });

  /* Remove a line */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cart-remove]') : null;
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form[data-location]');
    if (!form) return;
    var key = btn.getAttribute('data-cart-remove');
    var row = btn.closest('.cart__item');
    var next = row && (row.nextElementSibling || row.previousElementSibling);
    pendingFocus = { type: 'remove', key: next ? next.getAttribute('data-key') : null };
    announce((btn.getAttribute('data-remove-title') || 'Item') + ' removed from your cart.');
    doc.dispatchEvent(new CustomEvent('cart:quantity.cart-' + form.getAttribute('data-location'), {
      detail: [key, 0, row ? row.querySelector('.js-qty__wrapper') : null]
    }));
  });

  /* Remember which quantity control was used so focus can return to it */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('form[data-location] .js-qty__adjust') : null;
    if (!b) return;
    var row = b.closest('.cart__item');
    if (row) pendingFocus = { type: 'qty', key: row.getAttribute('data-key'), cls: b.classList.contains('js-qty__adjust--minus') ? '.js-qty__adjust--minus' : '.js-qty__adjust--plus' };
  }, true);
  doc.addEventListener('change', function (e) {
    var i = e.target.closest ? e.target.closest('form[data-location] .js-qty__num') : null;
    if (!i) return;
    var row = i.closest('.cart__item');
    if (row) pendingFocus = { type: 'qty', key: row.getAttribute('data-key'), cls: '.js-qty__num' };
  }, true);

  /* After the cart re-renders, put focus back somewhere useful */
  doc.addEventListener('cart:rendered', function (e) {
    if (!pendingFocus) return;
    // Only act on the cart the shopper is using: the open drawer, or the cart page form
    var wanted = cartIsOpenDrawer() ? 'cart-drawer' : (doc.body.classList.contains('template-cart') ? 'page' : 'cart-drawer');
    if (e.detail && e.detail.location && e.detail.location !== wanted) return;
    var pf = pendingFocus; pendingFocus = null;
    var scope = cartIsOpenDrawer() || doc.querySelector('#CartPageForm') || doc;
    var target = null;
    if (pf.type === 'qty' && pf.key) {
      var row = scope.querySelector('.cart__item[data-key="' + pf.key + '"]');
      target = row ? row.querySelector(pf.cls) : null;
    } else if (pf.type === 'remove') {
      var r = pf.key ? scope.querySelector('.cart__item[data-key="' + pf.key + '"]') : scope.querySelector('.cart__item');
      target = r ? r.querySelector('.cart__product-name') : null;
    } else if (pf.type === 'added' && pf.variant) {
      var a = scope.querySelector('.cart__item[data-variant-id="' + pf.variant + '"]');
      target = a ? a.querySelector('.cart__product-name') : null;
    }
    if (!target) {
      var empty = scope.querySelector && scope.querySelector('.cart-empty__btn');
      target = (e.detail && e.detail.count === 0 && empty) ? empty : (scope.querySelector && scope.querySelector('.drawer__close-button'));
    }
    if (target) setTimeout(function () { target.focus(); }, 50);
  });

  /* Announce quantity changes with the new subtotal */
  doc.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && typeof cart.total_price === 'number') {
      announce('Cart updated. ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ', subtotal ' + money(cart.total_price) + '.');
    }
  });

  /* Cart drawer: full focus trap in both directions (WCAG 2.4.3) */
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = cartIsOpenDrawer();
      if (open) { doc.dispatchEvent(new CustomEvent('cart:close')); var t = doc.querySelector('.js-drawer-open-cart'); if (t) setTimeout(function () { t.focus(); }, 50); }
      return;
    }
    if (e.key !== 'Tab') return;
    var drawer = cartIsOpenDrawer();
    if (!drawer) return;
    var items = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, iframe, [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1], active = doc.activeElement;
    if (!drawer.contains(active)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && (active === first || active === drawer || active.id === 'CartDrawerForm')) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }, true);
})();
